import { useTranslation } from 'react-i18next';
import { IneligibleReasonMappings } from '../../../utils/shiftOpportunityUtils';
export function useIneligiblityList(ineligibilityReasons, showAllReasons) {
    if (showAllReasons === void 0) { showAllReasons = false; }
    var t = useTranslation().t;
    if (ineligibilityReasons.length === 0) {
        return [];
    }
    var translatedReasonsList = [];
    ineligibilityReasons.forEach(function (reasonCode) {
        var translationKey;
        if (Object.keys(IneligibleReasonMappings).includes(reasonCode)) {
            translationKey = "shift_management_feature_opportunity_ineligibleReason_".concat(IneligibleReasonMappings[reasonCode]);
        }
        else {
            // Default to "UNKNOWN" message
            translationKey = "shift_management_feature_opportunity_ineligibleReason_".concat(IneligibleReasonMappings['SMS-9999']);
        }
        translatedReasonsList.push(t(translationKey));
    });
    // Dedupe translations
    translatedReasonsList = Array.from(new Set(translatedReasonsList));
    if (translatedReasonsList.length > 1) {
        var multipleIneligibilitiesText = t('shift_management_features_OpportunityCard_ineligibleText', {
            count: translatedReasonsList.length
        });
        // If showAllReasons flag is false, we just show the multiple ineligiblilities text
        if (!showAllReasons) {
            return [multipleIneligibilitiesText];
        }
        translatedReasonsList.unshift(multipleIneligibilitiesText);
    }
    return translatedReasonsList;
}
export function useOpportunityStatuses(_a) {
    var ineligibilityReasons = _a.ineligibilityReasons, showAllReasons = _a.showAllReasons;
    return {
        ineligibilityList: useIneligiblityList(ineligibilityReasons, showAllReasons)
    };
}
